/**
 * @author Ketan Shetye
 * @created 2025-10-25
 * @description common icon service
 */

import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { svgs } from 'src/assets/export.assets';

@Injectable({ providedIn: 'root' })
export class IconService {
  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {}

  registerAll(): void {
    Object.entries(svgs).forEach(([iconKey, iconData]) => {
      if (iconData.fromMaterial) {
        // Register a direct alias for Material icons
        this.iconRegistry.registerFontClassAlias(iconData.name, iconData.name);
      } else {
        // Register the custom SVG
        this.iconRegistry.addSvgIcon(
          iconKey,
          this.sanitizer.bypassSecurityTrustResourceUrl(`${iconData.path}`)
        );
      }
    });
  }
}
